import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Carousel from '@nerdwallet/react-carousel';

import { CenteredContainer } from '@nerdwallet/currency';

import ValuesModuleTile from './values-module-tile';

import styles from './values.module.less';

const ValuesModule = ({ tiles, isMobile }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <ValuesModuleTile {...tile} key={id} isMobile={isMobile} />
  ));

  return (
    <React.Fragment>
      <CenteredContainer className={styles.valuesContainer}>
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          className={styles.valuesCarousel}
        >
          {renderedTiles}
        </Carousel>
        <div className={styles.valuesSmorga}>{renderedTiles}</div>
      </CenteredContainer>
    </React.Fragment>
  );
};

ValuesModule.displayName = 'Values Module';

ValuesModule.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(ValuesModule.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
  isMobile: PropTypes.bool,
};

export default ValuesModule;
